import menuPathItems from "@/modules/App/Layout/Sidebar/paths";

import { useLocation } from "react-router-dom";

export const useMenuPath = () => {
  const { pathname } = useLocation();

  for (const item of menuPathItems)
    for (const path of item.paths) {
      if (matchPath(path.path, pathname))
        return {
          basePath: basePath(path.path),
          pathItem: path,
          pathname
        };
    }

  return {
    basePath: basePath(menuPathItems[0].paths[0].path),
    pathItem: menuPathItems[0],
    pathname
  };

  function matchPath(path: string, currPath: string) {
    if (currPath === "/detection") return path.toLocaleLowerCase().includes(currPath.toLocaleLowerCase());
    if (path !== "/") return currPath.toLocaleLowerCase().includes(path.toLocaleLowerCase());

    let regexPath =
      "^" +
      path
        .split("/")
        .map(e => (/:[^\s]+/.test(e) ? "[^\\s]+" : e))
        .join("/") +
      "$";
    if (new RegExp(regexPath).test(currPath)) return true;

    regexPath =
      "^" +
      path
        .split("/")
        .filter(e => !e.startsWith(":"))
        .join("/") +
      "$";
    return new RegExp(regexPath).test(currPath);
  }

  function basePath(path: string) {
    return path
      .split("/")
      .filter(e => !e.startsWith(":"))
      .join("/");
  }
};
